if (!customElements.get('announcement-bar-rotator')) {
  class AnnouncementBarRotator extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-announcement-slide]'));
      if (this.slides.length < 2) return;

      this.index = 0;
      this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.autoplay = this.dataset.autoplay !== 'false';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.onReducedMotionChange = () => {
        if (this.reducedMotion.matches) this.pause();
        else if (this.autoplay) this.play();
      };

      this.reducedMotion.addEventListener('change', this.onReducedMotionChange);
      this.addEventListener('mouseenter', this.pause.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      this.addEventListener('focusin', this.pause.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));

      if (this.autoplay && !this.reducedMotion.matches) this.play();
    }

    disconnectedCallback() {
      this.pause();
      this.reducedMotion.removeEventListener('change', this.onReducedMotionChange);
    }

    onMouseLeave() {
      if (this.autoplay && !this.reducedMotion.matches) this.play();
    }

    onFocusOut(event) {
      if (!this.contains(event.relatedTarget) && this.autoplay && !this.reducedMotion.matches) {
        this.play();
      }
    }

    play() {
      this.pause();
      this.timer = window.setInterval(() => this.showNext(), this.speed);
    }

    pause() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    showNext() {
      const current = this.slides[this.index];
      this.index = (this.index + 1) % this.slides.length;
      const next = this.slides[this.index];

      current.classList.remove('is-active');
      current.setAttribute('aria-hidden', 'true');
      next.classList.add('is-active');
      next.setAttribute('aria-hidden', 'false');
    }
  }

  customElements.define('announcement-bar-rotator', AnnouncementBarRotator);
}
